import ChevronDownIcon from "@static/core/icons/icon-chevron-down.svg?react";
import { Col } from "antd";
import { FunctionComponent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

interface SeeMoreTableWrapperProps {
  id: string;
  children: string | JSX.Element | JSX.Element[];
  step?: number;
  initialHeight?: number;
  showWrapper: boolean;
  className?: string;
  disableMaxHeight?: boolean;
}

const SeeMoreTableWrapper: FunctionComponent<SeeMoreTableWrapperProps> = ({
  id,
  children,
  step = 180,
  initialHeight = 220,
  showWrapper,
  className = "",
  disableMaxHeight = false,
}) => {
  const { t } = useTranslation();

  const wrapperRef = useRef<HTMLDivElement>(null);

  const [tableMaxHeight, setTableMaxHeight] = useState<number>(initialHeight);

  const getBillTableEnd = () => {
    const billTable = document.getElementById(id);
    return billTable
      ? billTable.getBoundingClientRect().height <= tableMaxHeight
      : false;
  };

  useEffect(() => {
    if (wrapperRef.current && !disableMaxHeight) {
      wrapperRef.current.style.maxHeight = `${tableMaxHeight}px`;
    }
  }, [wrapperRef.current, tableMaxHeight]);

  return (
    <Col className={`app-table-see-more-wrapper ${className}`}>
      <div ref={wrapperRef} className="overflow-hidden">
        {children}
      </div>
      {showWrapper && (
        <div
          className={`cursor-pointer text-center ${!getBillTableEnd() && "shadow-table-wrapper"} position-relative`}
        >
          <div
            onClick={(e) => {
              e.preventDefault();
              if (getBillTableEnd()) {
                setTableMaxHeight(initialHeight);
              } else {
                setTableMaxHeight(tableMaxHeight + step);
              }
            }}
          >
            {getBillTableEnd()
              ? t("offices.balanceAndStatistics.reduce")
              : t("offices.balanceAndStatistics.more")}
            <ChevronDownIcon
              className={`icon-30 ml-4 ${getBillTableEnd() ? "rotate-180" : ""}`}
            />
          </div>
        </div>
      )}
    </Col>
  );
};

export default SeeMoreTableWrapper;
